import React from 'react';
export const OidcProviderHelpArticleLink = (props) => {
    const { icon, link, text } = props;
    return (React.createElement("span", null, link &&
        React.createElement("a", { className: 'oidc-help-article-link', href: link, rel: 'noopener norefererr', target: '_blank' },
            icon,
            React.createElement("span", null, text))));
};
